import { useLazyQuery } from "@apollo/client/react"; import { Fragment, useEffect, useState, useMemo } from "react";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import CardBox from "../../CardBox/CardBox";
import InfoRow from "../../InfoRow/InfoRow";
import { Button, IconButton, Grid } from "@mui/material";
import { CustomDialog } from "../../../../../../components/customDialog/CustomDialog";
import CloseIcon from '@mui/icons-material/Close';
import DataGridGenerico from "../../../../../../components/dataGrid/DataGridGenerico";
import { generateColumnsDefaultConfiguration } from "../../../../../../components/dataGrid/columnHelpers";

import { GET_CONTRATOS_VISITA, parseContratosVisita } from "../../../../../../data/graphQL/queries/MisVisitas/getContratosByVisita";
import { GET_INFORMACION_GENERAL, parseInformacionGeneral } from "../../../../../../data/graphQL/queries/MisVisitas/getInfoGeneral";
import { useStepSave } from "../../../../hooks/useStepSave";
import { useVisita } from "../../../../../../context/VisitaContext";

const constratosColumns = [
  { field: 'idEvaluacion', headerName: '#', width: 90 },
  { field: 'nombrePlan', headerName: 'Plan', width: 150 },
  { field: 'periodo', headerName: 'Fecha', width: 150 }];


export default function InformacionContratoCP({ idPaciente, idEvaluacion, idProfesional, idFrecuencia, onSaveRef, visitasProgramadas, periodo }) {
  const [formData, setFormData] = useState({});
  const { visita, setVisita } = useVisita();
  const [openModal, setOpenModal] = useState(false);
  const [contratosVisita, setContratosVisita] = useState([]);

  const [getContratosVisita, { data: dataContratosVisita }] = useLazyQuery(GET_CONTRATOS_VISITA, {
    skip: !idPaciente
  });

  useEffect(() => {
    if (!dataContratosVisita) return;
    const parsedData = dataContratosVisita?.evaluacionesByIdPaciente ? parseContratosVisita(dataContratosVisita.evaluacionesByIdPaciente) : [];
    setContratosVisita(parsedData);
  }, [dataContratosVisita]);

  const [getInformacionGeneral, { data: dataInformacionGeneral }] = useLazyQuery(GET_INFORMACION_GENERAL, {
    skip: !idEvaluacion || !idProfesional || !idFrecuencia
  });

  useEffect(() => {
    if (!dataInformacionGeneral) return;
    if (dataInformacionGeneral?.informacionGeneralVisita?.success) {
      setVisita((prev) => ({
        ...prev,
        ...parseInformacionGeneral(dataInformacionGeneral.informacionGeneralVisita),
        visitas: visitasProgramadas,
        periodo: periodo
      }));
    }
  }, [dataInformacionGeneral]);

  useEffect(() => {
    if (!idPaciente) return;
    getContratosVisita({ variables: { idPaciente } });
  }, [idPaciente]);

  useEffect(() => {
    if (!idEvaluacion || !idProfesional || !idFrecuencia) return;
    getInformacionGeneral({ variables: { idEvaluacion, idProfesional, idFrecuencia } });
  }, [idEvaluacion, idPaciente, idFrecuencia]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const configuratedColumns = generateColumnsDefaultConfiguration(constratosColumns);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useStepSave(onSaveRef, async (validate) => {
    // if (validate) validateStepFields({ formattedGroups, formData });

    // const { data } = await save({ variables: { input: adaptAddVisitaTeleEnfermeriaAPInput(formData) } });

    // const idTeleEnfermeriaAPNueva = data?.saveVisitaTeleEnfermeriaAP?.idTeleEnfermeriaAP;
    // if (!idTeleEnfermeriaAPNueva) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData
      // idTeleEnfermeriaAP: idTeleEnfermeriaAPNueva
    }));
  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  return (
    <CardBox>
      {inputs.map((input) => {
        return (
          <Fragment key={input.name}>
            {input.name === 'idEvaluacion' &&
              <InfoRow sxLabel={{ display: 'flex', alignItems: 'center' }} label={<>
                {input.displayName}
                {/* <Button
                   size="small"
                   onClick={handleOpenModal}
                   sx={{
                       marginLeft: 0.5,
                       textTransform: 'none',
                       fontWeight: 600
                   }}
                >Ver más</Button> */}
              </>} value={visita[input.name]} />
            }
            {input.name !== 'idEvaluacion' && <RenderInputByTypeMobile
              input={input}
              value={visita[input.name]} />
            }
          </Fragment>);

      })}
      <Grid size={{ xs: 12 }}>
        <RenderInputByTypeMobile
          input={{
            name: 'directivas',
            displayName: 'Directivas Anticipadas',
            type: 'string'
          }}
          value={formData['directivas']}
          handleChange={handleChange} />

      </Grid>
      <CustomDialog
        open={openModal}
        onCancel={handleCloseModal}
        cancelText="Cerrar"
        title="Contratos"
        maxWidth="sm"
        fullWidth>

        <IconButton onClick={handleCloseModal} sx={{ display: 'block', position: 'absolute', top: '4px', right: '8px' }}>
          <CloseIcon />
        </IconButton>

        <DataGridGenerico
          rows={contratosVisita || []}
          columns={configuratedColumns}
          hideFooterPagination={true} />

      </CustomDialog>
    </CardBox>);

}

const inputs = [
  {
    name: 'idEvaluacion',
    displayName: 'Contrato',
    type: 'custom'
  },
  {
    name: 'periodo',
    displayName: 'Periodo',
    type: 'infoRow'
  },
  {
    name: 'programa',
    displayName: 'Programa',
    type: 'infoRow'
  },
  {
    name: 'planAsistencial',
    displayName: 'Plan Asistencial',
    type: 'infoRow'
  },
  {
    name: 'cliente',
    displayName: 'Financiador',
    type: 'infoRow'
  },
  {
    name: 'frecuencia',
    displayName: 'Frecuencia de Visita',
    type: 'infoRow'
  },
  {
    name: 'visitas',
    displayName: 'Visitas',
    type: 'infoRow'
  }];